import type { Typography } from '../../style';
import DefaultTypography from '../default/Typography';
import RcmReportTypography from '../rcm-report/Typography';

export const getTypographyTheme = (theme: string): Typography =>
  theme === 'rcm-report' ? RcmReportTypography : DefaultTypography;
